export default __webpack_public_path__ + "static/media/Group1753.f8721474.svg";